// src/services/reports/HeatReport.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { AGDYSA_LOGO_BASE64 } from "../../assets/logoBase64";

export const generateHeatReport = (data, results) => {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  // CONFIGURACIÓN DE MÁRGENES (20mm = 2cm)
  const margin = 20;
  const pageWidth = doc.internal.pageSize.width;
  const rightLimit = pageWidth - margin;
  const contentWidth = pageWidth - (margin * 2);

  // 1. LOGO (PNG en Base64)
  try {
    const imgProps = doc.getImageProperties(AGDYSA_LOGO_BASE64);
    const logoWidth = 18.5; // Ancho fijo que desees en mm
    const logoHeight = (imgProps.height * logoWidth) / imgProps.width; // Calcula altura proporcional
    // Ajustamos posición para que respete el margen de 2cm
    doc.addImage(AGDYSA_LOGO_BASE64, "PNG", margin, 12, logoWidth, logoHeight);
  } catch (e) {
    console.error("Error al cargar el logo", e);
  }

  // 2. ENCABEZADO "AGDYSA" (Sombreado y Letra Gruesa)
  doc.setFillColor(235, 235, 235); // Gris claro para el sombreado
  doc.rect(margin + 28, 12, 100, 8, "F"); 
  
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(30, 90, 58); // Verde AGDYSA (Argumentos separados)
  doc.text("AGDYSA", margin + 30, 18);

  // 3. SUBTÍTULO (Pequeño y Sombreado)
  doc.setFillColor(245, 245, 245);
  doc.rect(margin + 28, 20, 100, 5, "F");
  
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor(100, 100, 100); // Gris
  doc.text("REPORTE TÉCNICO DE ESTRÉS TÉRMICO", margin + 30, 23.5);

  // Línea divisoria técnica
  doc.setDrawColor(30, 90, 58);
  doc.setLineWidth(0.5);
  doc.line(margin, 30, rightLimit, 30);

  // 4. INFORMACIÓN GENERAL
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0); // Negro
  doc.text(`Fecha de Evaluación: ${new Date().toLocaleDateString()}`, margin, 40);
  doc.text(`Normativa Aplicada: ISO 7243:2017`, margin, 45);

  // 5. TABLA DE MEDICIONES
  autoTable(doc, {
    startY: 50,
    margin: { left: margin, right: margin },
    head: [["PARÁMETRO", "VALOR REGISTRADO"]],
    body: [
      ["Temperatura Bulbo Húmedo (Tnw)", `${data.tgb} °C`],
      ["Temperatura de Globo (Tg)", `${data.tg} °C`],
      ["Trabajador", data.acclimatized === "acclimatized" ? "Aclimatado" : "No Aclimatado"],
      ["Carga Metabólica", data.workClass.replace('class', 'Clase ')],
      ["Ajuste de Ropa (CAV)", `+${results.cav} °C`],
    ],
    headStyles: { fillColor: [30, 90, 58], fontSize: 10, fontStyle: 'bold' },
    styles: { fontSize: 9, cellPadding: 3 },
    theme: "striped"
  });

  // 6. RESULTADOS DESTACADOS
  const finalY = doc.lastAutoTable.finalY + 15;
  
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(30, 90, 58);
  doc.text("DIAGNÓSTICO TÉCNICO:", margin, finalY);

  // Caja de Resultado (Lógica corregida para evitar error f3)
  const isHazard = results.status.label.toLowerCase().includes("peligro");
  
  // Fondo de la caja
  if (isHazard) {
    doc.setFillColor(255, 240, 240); // Rojo pálido
  } else {
    doc.setFillColor(240, 255, 240); // Verde pálido
  }
  doc.rect(margin, finalY + 4, contentWidth, 20, "F");
  
  // Texto del resultado (CORRECCIÓN: Argumentos separados, no array)
  if (isHazard) {
    doc.setTextColor(180, 0, 0); // Rojo
  } else {
    doc.setTextColor(30, 90, 58); // Verde
  }

  doc.setFontSize(14);
  doc.text(`WBGT EFECTIVO: ${results.effectiveWBGT} °C`, margin + 5, finalY + 13);
  
  doc.setFontSize(10);
  doc.text(`ESTADO: ${results.status.label.toUpperCase()}`, margin + 5, finalY + 19);

  // 7. RÉGIMEN DE TRABAJO
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.text("RÉGIMEN DE TRABAJO/DESCANSO RECOMENDADO:", margin, finalY + 35);
  
  autoTable(doc, {
    startY: finalY + 38,
    margin: { left: margin, right: margin },
    body: [
      ["TRABAJO", results.cycle.work],
      ["DESCANSO", results.cycle.rest],
      ["OBSERVACIONES", results.cycle.note]
    ],
    styles: { fontSize: 9, fontStyle: "bold" },
    columnStyles: { 0: { cellWidth: 50, fillColor: [245, 245, 245] } },
    theme: "grid"
  });

  // Pie de página
  doc.setFontSize(7);
  doc.setTextColor(150, 150, 150);
  doc.text("Este reporte es un entregable automatizado del sistema AGDYSA. Verifique las calibraciones de sus equipos.", margin, 285);

  doc.save(`AGDYSA_REPORTE_ESTRES_TERMICO_${Date.now()}.pdf`);
};
/*<!--© 2026 Todos los derechos reservados Desarrollado por JEMAprod-Tecnologia-->*/